<template>
  <div>
    <b-card>
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form @submit.stop.prevent="onSubmit">
        <div>
          <b-row>
            <b-col>
              <b-form-group label="نام مشتری: " label-for="input_customer_name">
                <b-form-input
                  id="input_customer_name"
                  aria-describedby="input_customer_name_describe"
                  v-model="Input.customer_name"
                  placeholder="نام مشتری "
                  :state="validateState('customer_name')"
                ></b-form-input>
                <b-form-invalid-feedback id="input_customer_name_describe"
                  >نام مشتری را وارد کنید</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="تلفن همراه مشتری: "
                label-for="input_customer_mobile"
              >
                <b-form-input
                  id="input_customer_mobile"
                  aria-describedby="input_customer_mobile_describe"
                  v-model="Input.customer_mobile"
                  :state="validateState('customer_mobile')"
                  placeholder="تلفن همراه مشتری "
                ></b-form-input>
                <b-form-invalid-feedback id="input_customer_mobile_describe"
                  >تلفن همراه مشتری را وارد کنید</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                class="tooltip-custom"
                id="input-group-5"
                label="تاریخ سر رسید:"
                label-for="input-5"
              >
                <span class="tooltiptext"
                  >بعد از تاریخ سررسید فاکتور قابل پرداخت می باشد</span
                >
                <date-picker clearable required v-model="Input.due_date"></date-picker>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                class="tooltip-custom"
                id="input-group-4"
                label="تاریخ انقضا:"
                label-for="input-4"
              >
                <span class="tooltiptext"
                  >بعد از تاریخ انقضا فاکتور قابل پرداخت نمی باشد</span
                >

                <date-picker clearable required v-model="Input.expire_date" :min="Input.due_date"></date-picker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group
            id="input-group-3"
            label="توضیحات: "
            label-for="input-3"
          >
            <b-form-textarea
              id="input-3"
              v-model="Input.description"
              placeholder="توضیحات"
              rows="8"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <br />
        <br />
        <h3>جزییات فاکتور</h3>
        <br />
        <b-button class="mr-3" variant="success" @click="addNew()"
          >اضافه کردن جزییات</b-button
        >
        <b-row class="mt-5">
          <b-col cols="6">نام محصول</b-col>
          <b-col cols="1">تعداد</b-col>
          <b-col cols="2">قیمت واحد(ریال)</b-col>
          <b-col cols="2">درصد مالیات</b-col>
          <b-col cols="1"></b-col>
        </b-row>
        <b-row
          class="mt-1"
          v-for="(x, index) in $v.Input.factor_details.$each.$iter"
          :key="index"
        >
          <b-col cols="6" v-if="index == Input.factor_details.length - 1">
            <b-form-input
              v-bind:class="{
                'is-invalid': !x.service_name.required && x.service_name.$dirty,
                'is-valid': x.service_name.required && x.service_name.$dirty,
              }"
              v-model="x.service_name.$model"
              :aria-describedby="'input_service_name_describe_' + index"
              placeholder="نام محصول"
              @focus="addNew()"
            ></b-form-input>
            <b-form-invalid-feedback
              :id="'input_service_name_describe_' + index"
              >نام محصول را وارد کنید</b-form-invalid-feedback
            >
          </b-col>

          <b-col cols="6" v-else>
            <b-form-input
              v-bind:class="{
                'is-invalid': !x.service_name.required && x.service_name.$dirty,
                'is-valid': x.service_name.required && x.service_name.$dirty,
              }"
              v-model="x.service_name.$model"
              :aria-describedby="'input_service_name_describe_' + index"
              placeholder="نام محصول"
            ></b-form-input>

            <b-form-invalid-feedback
              :id="'input_service_name_describe_' + index"
              >نام محصول را وارد کنید</b-form-invalid-feedback
            >
          </b-col>
          <b-col cols="1">
            <NumberSeprator v-model="x.service_count.$model"></NumberSeprator>
          </b-col>
          <b-col cols="2">
            <NumberSeprator v-model="x.service_price.$model"></NumberSeprator>
          </b-col>
          <b-col cols="2">
            <NumberSeprator v-model="x.add_tax.$model"></NumberSeprator>
          </b-col>
          <b-col cols="1" class="text-center aligner">
            <div v-if="index == Input.factor_details.length - 1">
              <b-icon
                @click="addNew()"
                icon="plus"
                variant="success"
                font-scale="2"
              ></b-icon>
            </div>
            <div v-else style="width: 22px"></div>

            <b-icon
              @click="removeItem(x.id.$model, index)"
              v-if="
                Input.mdid106_status == 1674 || Input.mdid106_status == null
              "
              icon="trash"
              variant="danger"
              font-scale="1.2"
            ></b-icon>
          </b-col>
        </b-row>
        <br />
        <b-button
          v-if="Input.mdid106_status == 1674 || Input.mdid106_status == null"
          type="submit"
          class="mr-3"
          variant="success"
          >ثبت</b-button
        >
        <b-button class="mr-3" variant="danger" href="/Factors"
          >بازگشت</b-button
        >
      </b-form>
    </b-card>
  </div>
</template>
<style>
.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}
.tooltip-custom {
  position: relative;
}

.tooltip-custom .tooltiptext {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip-custom:hover .tooltiptext {
  visibility: visible;
}
.tooltip-custom .tooltiptext::after {
  content: " ";
  position: absolute;
  top: 100%; /* At the bottom of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}
.tooltip-custom .tooltiptext {
  top: -29px;
  left: 29%;
  margin-left: -60px;
  padding: 8px;
}
.custom-select.is-valid,
.was-validated .custom-select:valid {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%231B283F' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
      no-repeat left 1rem center/8px 10px,
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath fill='%231BC5BD' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E")
      #fff no-repeat center left 2rem / calc(0.75em + 0.65rem)
      calc(0.75em + 0.65rem);
}

.custom-select.is-invalid,
.was-validated .custom-select:invalid {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%231B283F' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
      no-repeat left 1rem center/8px 10px,
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23F64E60'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23F64E60' stroke='none'/%3E%3C/svg%3E")
      #fff no-repeat center left 2rem / calc(0.75em + 0.65rem)
      calc(0.75em + 0.65rem);
}
</style>
<script>
import { validationMixin } from "vuelidate";
import { email, required, minLength, url } from "vuelidate/lib/validators";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import NumberSeprator from "../../components/numberSeprator";

//const mobile = (value, vm) => /09\d{9}/g.test(value);
const mobile = (value, vm) => /^[\u06F0-\u06F9\s||z0-9]{11}$/.test(value);
const fachars = (value, vm) => /[^A-Za-z0-9]/.test(value);

export default {
  mixins: [validationMixin],
  name: "addFactor",
  components: {
    persianDate,
    NumberSeprator,
  },
  data: function () {
    return {
      Input: {
        customer_name: "",
        customer_mobile: "",
        description: "",
        due_date: "",
        expire_date: "",
        factor_details: [
          {
            id: 0,
            index: 0,
            service_name: null,
            service_count: 0,
            service_price: 0,
            add_tax: 0,
            detaileds: [],
          },
        ],
      },
      errors: [],
    };
  },
  validations: {
    Input: {
      customer_name: {
        required,
        fachars,
        minLength: minLength(3),
      },
      customer_mobile: {
        required,
        mobile,
      },
      // service_name: {
      //   required,
      //   minLength: minLength(3),
      // },
      factor_details: {
        $each: {
          service_name: {
            required,
            minLength: minLength(3),
          },
          service_count: {},
          service_price: {},
          add_tax: {},
          id:{},
        },
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.Input[name];
      return $dirty ? !$error : null;
    },
    onSubmit(evt) {
      this.$v.Input.$touch();
      if (this.$v.Input.$anyError) {
        return;
      }
      this.errors = [];
      var removeObj = [];
      this.Input.factor_details.forEach(function (item, index, object) {
        if (
          item.service_name != null &&
          item.service_name != "" &&
          item.service_count != null &&
          item.service_count != "" &&
          item.service_price != null &&
          item.service_price != "" &&
          item.add_tax != null &&
          item.add_tax != ""
        ) {
          removeObj.push(item);
        }
      });
      this.Input.factor_details = removeObj;
      if (this.$route.params.id != null) {
        this.Input.id = this.$route.params.id;
      } else {
        if (
          this.Input.factor_details.length > 0 &&
          this.Input.factor_details[this.Input.factor_details.length - 1]
            .service_name == null
        ) {
          this.Input.factor_details.splice(
            this.Input.factor_details.length - 1,
            1
          );
        }
      }
      httpHelper.postData("factor", this.Input).then((response) => {
        if (response.success) {
          this.$router.push("/factors");
        } else {
          if (this.Input.factor_details.length == 0) {
            this.Input.factor_details.push({
              index: 0,
              id: 0,
              service_name: null,
              service_count: 0,
              service_price: 0,
              add_tax: 0,
              detaileds: [],
            });
          }
          for (var key in response.error) {
            response.error[key].forEach((element) => {
              this.errors.push(element);
            });
          }
        }
      });
    },
    addNew() {
      this.Input.factor_details.push({
        index: this.Input.factor_details.length,
        id: 0,
        service_name: null,
        service_count: 0,
        service_price: 0,
        add_tax: 0,
        detaileds: [],
      });
    },
    removeItem(selectdId, selected_index) {
      if (selectdId != 0) {
        httpHelper.getData("factordetail/" + selectdId).then((response) => {
          if (response.success) {
          } else {
            if (response.error.length > 1) {
              for (var key in response.error) {
                response.error[key].forEach((element) => {
                  this.errors.push(element);
                });
              }
            } else {
              this.errors.push(response.error[0]);
            }
          }
        });
      }
      this.Input.factor_details.splice(
        this.Input.factor_details.indexOf(selected_index),
        1
      );
      if (this.Input.factor_details.length == 0) {
        this.addNew();
      }
    },
  },
  mounted() {
    if (this.$route.params.id != null) {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "فاکتور ها", route: "/factors" },
        { title: "ویرایش فاکتور" },
      ]);
      httpHelper.getData("factor?id=" + this.$route.params.id).then((res) => {
        if (res.success && res.result !== null) {
          this.Input = res.result;
          this.Input.due_date = persianDate.getDateByFormat(
            new Date(this.Input.due_date)
          );
          this.Input.expire_date = persianDate.getDateByFormat(
            new Date(this.Input.expire_date)
          );
          if (this.Input.factor_details.length == 0) {
            this.addNew();
          }
        }
      });
    } else {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "فاکتور ها", route: "/factors" },
        { title: "فاکتور جدید" },
      ]);
    }
  },
};
</script>